import { useLocalObservable } from 'mobx-react-lite';

import Tasks from 'APP/Tasks';

import User from './Entities/User';

const LIMIT = 10;

export const useSeenPresenter = ({ groupId, messageId }) => {
  const presenter = useLocalObservable(() => ({
    isLoading: false,
    cursor: '',
    users: [],

    loadUsersViewedMessage: async (loadMore = false) => {
      presenter.isLoading = true;

      const { userIds, cursor } = await Tasks.messaging.getUsersViewedMessage({
        groupId: groupId,
        messageId: messageId,
        limit: LIMIT,
        cursor: presenter.cursor || undefined,
      });

      await Tasks.relationships.loadUnknownUsersByIds({ usersIds: userIds });

      const list = userIds
        .map((userId) => presenter.createUser({ userId, groupId, messageId }))
        .filter((x) => x.user);

      if (loadMore) {
        presenter.users = [...presenter.users, ...list];
      } else {
        presenter.users = list;
      }

      presenter.cursor = cursor;
      presenter.isLoading = false;
      return presenter.users;
    },

    get hasMore() {
      return !!presenter.cursor;
    },

    loadMore: () => {
      if (presenter.cursor) {
        presenter.loadUsersViewedMessage(true);
      }
    },

    createUser: (data) => {
      return new User(presenter, data);
    },
  }));

  return presenter;
};
